import { Pipe, PipeTransform } from '@angular/core';
import { IMagazineCategory } from '../models/magazine-result';

@Pipe({
    name: 'magazineCategoryFilter',
    pure: false
})
export class MagazineCategoryPipe implements PipeTransform {
    transform(
        categories: any[],
        filter: IMagazineCategory
    ): IMagazineCategory[] {
        if (!categories || !filter) {
            return categories;
        }

        return categories.filter(
            category =>
                category.isActive === filter.isActive ||
                category.name.indexOf(filter.name) !== -1
        );
    }
}
